import { Hero, Intro, MainImage, RightImage, LeftImage, Gallery, Contacts, GalleryContainer } from './components'
import { motion, useScroll, useSpring } from "framer-motion"
//import { images } from './data/gallery';
import './App.css';
//import { useState } from 'react';

function App() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress);
  //const [galleryON, setGalleryON ] = useState(false);
  //const [currentImg, setCurrentImg] = useState(0);

  /* const changeImageGallery = (direction) => {

    if(direction === 'left') {
        if(currentImg === 0){
          setCurrentImg(images.length - 1);
        } else {
          setCurrentImg((prevImg) => prevImg - 1);
        }
      
    } else if(direction === 'right') {
        if(currentImg === images.length - 1){
          setCurrentImg(0);
        } else {
          setCurrentImg((prevImg) => prevImg  + 1);
        }  
    }
  } */
  
  return (
    <div className="App">
        <GalleryContainer />
        <motion.div className="progress-bar" style={{ scaleX }} />
        {/* SECTION HERO */}
        <Hero />
        
        {/* SECTION INTRO */}
        <Intro />

        {/* SECTION MAIN-IMAGE */}
        <MainImage />

        {/* SECTION RIGHT-IMAGE */}
        <RightImage />

        {/* SECTION left-IMAGE */}
        <LeftImage
            myId="left-image"
            myImg="https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/23c9298f-1237-4cef-a893-8fec16b7663b/MARTA_BRANDAO_AROUCA_LOW-24.jpg"
            myTitle="The Master Bedroom"
            myText="At the upper floor, the sloping ceiling of the master bedroom, with its wooden structure and generous ceiling height, conveys grandeur. Throughout the bedroom runs a narrow balcony that culminates in the outdoor terrace where there are sofas integrated into the structure and a small swimming pool elevated over the fraga."
            selectorUp="#right-image"
            selectorDown="#galery"
          />

        {/* SECTION galery */}
        <Gallery />

        {/* SECTION perfect getaway */}
        <LeftImage
            myId="perfect-getaway"
            myImg="https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/1938d705-5dbe-4ca8-92b7-c4a05accbe58/MARTA_BRANDAO_AROUCA_LOW-53.jpg"
            myTitle="The perfect getaway"
            myText="The sumptuous green panorama becomes the perfect backdrop for contemplation, while the sun peeks through the wooden slats, generating poetic games of light throughout the house, favoring a permanent dialogue between the outside and the inside. The house punctuates the landscape and generates a new landscape. The result of this symbiosis is the perfect refuge from the hustle and bustle of daily life, where you can enjoy nature in full built comfort and pure visual delight."
            selectorUp="#galery"
            selectorDown="#contacts"
          />
        {/* SECTION contacts */}
        <Contacts />
        
    </div>
  );
}

export default App;
